import useCountdown from '@bradgarropy/use-countdown';
import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ball from '../../../assets/images/pong/ball.png';
import cups from '../../../assets/images/pong/cups.png';
import { Container, Cups, Root, StyledBoard } from './styles';

export const Board = () => {
  const [alert, setAlert] = useState(false);
  const ref = useRef<any>();
  const boardRef = useRef<any>();
  const [throwBall, setThrowBall] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [searchParams] = useSearchParams();
  const transaction = searchParams.get('transaction');
  const result = transaction;
  const navigate = useNavigate();

  const [go, setGo] = useState('not-ready');
  const [complete, setComplete] = useState(false);

  const countdown = useCountdown({
    seconds: 3,
    onCompleted: () => {
      if (!throwBall) return;
      setComplete(true);
      setClicked(false);
      setAlert(true);
    },
  });

  useEffect(() => {
    if (clicked) {
      setThrowBall(true);
      handleThrowBall();
      setClicked(false);
    }
  });
  const onReset = () => {
    countdown.reset();
  };

  const handleThrowBall = () => {
    setClicked(true);
    onReset();
    setThrowBall(true);
    setComplete(false);
    setGo(result || '0');
  };

  useEffect(() => {
    if (result === '0') {
      window.sessionStorage.setItem('state', '5');
    } else {
      window.sessionStorage.setItem('state', '4');
    }
  }, []);

  console.log(boardRef.current?.offsetWidth);

  return (
    <Container>
      <Root>
        <StyledBoard ref={boardRef}>
          <button
            style={{
              background: '#e02f29',
              fontSize: '30px',
              padding: '10px 30px',
              cursor: 'pointer',
              zIndex: 9999,
              position: 'absolute',
              top: -80,
              left: -6,
              borderColor: '#fff',
            }}
            onClick={complete ? () => navigate('/') : () => handleThrowBall()}
          >
            {complete ? 'Next' : 'Go'}
          </button>

          <motion.img
            className='ball'
            transition={{
              x: {
                type: 'spring',
                stiffness: 10,
                duration: 1,
                bounce: [0.17, 0.67, 1, 0.67],
                damping: 300,
              },
            }}
            animate={
              go === '1' && complete
                ? {
                    x: [
                      '30px',
                      Number(boardRef.current?.offsetWidth) -
                        (Number(boardRef.current?.offsetWidth) / 100) * 5 +
                        'px',
                      Number(boardRef.current?.offsetWidth) -
                        (Number(boardRef.current?.offsetWidth) / 100) * 16 +
                        'px',
                    ],
                  }
                : go === '0' && complete
                ? {
                    x: [
                      '30px',
                      Number(boardRef.current?.offsetWidth) -
                        (Number(boardRef.current?.offsetWidth) / 100) * 22 +
                        'px',
                      Number(boardRef.current?.offsetWidth) -
                        (Number(boardRef.current?.offsetWidth) / 100) * 32 +
                        'px',
                    ],
                  }
                : {}
            }
            ref={ref}
            src={ball}
            alt='ball'
          />
          <Cups src={cups} alt='cups' />

          {alert && complete && throwBall ? (
            <motion.div
              transition={{ delay: 1 }}
              className='custom-alert'
              onClick={() => {
                // setAlert(false);
                // setGo('reset');
                // setComplete(false);
                // setThrowBall(false);
                navigate('/');
              }}
            >
              {go === '1' ? <h2>Nice Shot!</h2> : <h2>So Close!</h2>}
            </motion.div>
          ) : (
            ''
          )}

          {throwBall && !complete && (
            <AnimatePresence>
              <motion.h2
                className='counter-text'
                key={countdown.seconds}
                exit={{
                  opacity: 0,
                  position: 'absolute',
                  scale: 2,
                }}
                initial={{ opacity: 0, scale: 1 }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                transition={{
                  ease: 'easeOut',
                  duration: 1,
                }}
              >
                {countdown.seconds === 0 ? 'Go' : countdown.seconds}
              </motion.h2>
            </AnimatePresence>
          )}
        </StyledBoard>
      </Root>
    </Container>
  );
};
